Librarian.Modules.CategoryContent = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onDataLoaded", "prepCartItem"],

    options: {
        classPrefix: "modules-categorycontent-",
        catType: Librarian.catType.file,
        catPath: null,
        // Whether to display a list of categories at the given path
        categories: false,
        // Whether to flatten the tree structure at the given path to a flat list of content
        flatten: false,
        action: "open", // Or "preview",
        useGetSendData: true,
        overlayClass: null,
        // Don't show error, Use for GF Builder categories since they might not be there
        suppressFailure: false,
        // If true, tries to use name before title, instead of title before name
        displayFilename: false,
        // Show detailed information
        detailed: false,
        // Show Get Link option, 'detailed' must be true if enabled
        showGetLink: false,
        // Show Share Link option, turn off for certain user groups
        showShareLink: true,
        // Only use if displayFilename is true
        stripExtension: false,
        // Function to call after rendering is complete
        onPostRender: null,
        // Whether or not to use the content's 'Title' metadata as the name
        useTitleMetadata: false,
        // Show loading spinner
        spinner: false,
        // Number of files to show
        count: null,
        // Value to order results by
        orderBy: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
        this.items = [];
    },

    reload: function() {
        // Make sure we don't destroy the wrapper,
        // but save the set value so we can reset it after
        var destroyWrapperVal = this.destroyWrapper;
        this.destroyWrapper = false;

        this.destroy();
        this.load();

        // Reset the saved value
        this.destroyWrapper = destroyWrapperVal;
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        if (this.options.spinner) {
            this.loadingImage = new Element("div",
            {
                "class": "recentLoadingSpinner"
            }).inject(this.wrapperEl);
        }

        // Assume we're loading files, for now
        var rootCat = 0,
            method = this.options.categories ? "getcc" : (this.options.flatten ? "getcfi" : "getfiles"),
            view = "";
        // If the catType was set to Global Favorites, load that instead
        if (this.options.catType === Librarian.catType.globalFavorite) {
            if (Librarian.specialCategories && Librarian.specialCategories.GlobalFavorites)
                rootCat = Librarian.specialCategories.GlobalFavorites.CatId;
            method = this.options.flatten ? "getccgi" : "getcg";
            if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS])
                view = "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS];
        }
        // If the catType was set to My Favorites, load that instead
        else if (this.options.catType === Librarian.catType.myFavorite) {
            // TODO
            if (this.options.flatten)
                throw "'Flatten' option is not implemented for My Favorites";

            method = this.options.categories ? "getvpcc" : "getvps";
            if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.MYFAVORITE])
                view = "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.MYFAVORITE];
        }
        else if (this.options.categories) {
            if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.CATEGORIES])
                view = "&cvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.CATEGORIES];
            
        }
        else if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES])
            view = "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];

        // Create the container element and generate the URL
        var url = Librarian.path.getMethodUrl(method) + "&out=ujson";
        if (this.options.catPath)
            url += "&pcid=" + rootCat + "&cpath=" + encodeURIComponent(this.options.catPath);
        else
            url += "&cid=" + rootCat;

        if (Librarian.elasticSearch.enableContent) {
            url += "&usees=1";

            if (Librarian.elasticSearch.includeView)
                url += view;
        }
        else
            url += view;

        if (this.options.count)
            url+= "&perpage=" + this.options.count;

        var options = {
            url: url,
            onSuccess: this.onDataLoaded,
            onFailure: function(error) {
                if (!self.options.suppressFailure)
                    Librarian.Utils.onFailure(error);
            }
        };

        var data = {};
        if ((typeof this.options.customSendData == "function")) {
            data = this.options.customSendData(data, url);
            if (data) {
                // If the given data is an object, stringify it
                if (typeof data.data == "object")
                    data.data = JSON.stringify(data.data);
                // Convert the data to Base64
                if (typeof Base64 != "undefined")
                    data.data = Base64.encode(data.data);

                // And save it
                options.data = data.data;
                options.method = "post";
                if (data.url)
                    options.url = data.url;
            }
        }

        // If we have a custom data function
        if (typeof Library.getSendData == "function" && this.options.useGetSendData) {
            // Get the data to send and check that it is valid
            data = Library.getSendData({ cattype: this.options.catType }, options.url);
            if (data) {
                // If the given data is an object, stringify it
                if (typeof data.data == "object")
                    data.data = JSON.stringify(data.data);
                // Convert the data to Base64
                if (typeof Base64 != "undefined")
                    data.data = Base64.encode(data.data);

                // And save it
                options.data = data.data;
                options.method = "post";
                options.url = data.url;
            }
        }

        this.request = new Librarian.Request.JSON(options);
        this.request.send();
    },

    onDataLoaded: function(json) {
        // remove loading image
        if (this.loadingImage) {
            this.wrapperEl.getElements(".recentLoadingSpinner").destroy();
        }

        var listEl = new Element("ul", {
                "class": "content-list"
            }).injectInside(this.containerEl),
            self = this;

        if (!json)
            return;

        var catId = json.CatId,
            items;
        // If we're told to load categories, use the inner subcategories list as the items list
        if (this.options.categories)
            items = json.SubCategories;
        else if (typeOf(json) == "array")
            items = json;
        // Otherwise, aggregate all the sub lists into one
        else {
            var groups = json.Groups || [],
                files = json.Files || [],
                presentations = json.Presentations || [];

            items = files.concat(groups).concat(presentations);
        }

        if (!items || (items.length == 0))
            return;

        if (this.options.detailed) {
            var viewAllEl = new Element("span", {
                "class": "content-view-all",
                "text": "View All"
            }).injectInside(this.headerEl);

            viewAllEl.addOnClick(function() {
                Librarian.Modules.OpenCat.openCategory(0, self.options.catPath);
                Librarian.Init.toggleSideColumn(sideColumn, true, true);
            });
        }

        // Add a row for each item in the list which links back to the item
        items.forEach(function(item) {
            var url = '#',
                data = Object.toLowerKeys(item),
                name = (this.options.displayFilename) ? (item.Name || item.Title) : (item.Title || item.Name),
                moddate = Librarian.Utils.getDateValue(item.LastModDate, "%x %X");

            if (this.options.useTitleMetadata) {
                var type = item.CatId ? "folder" : "file";
                var formattedName = Librarian.TreeView.getFormattedName(name, item, type);
                if (formattedName && formattedName.length > 0) {
                    name = formattedName;
                }
            }

            if (this.options.stripExtension)
                name = Librarian.Utils.getNameWithoutExtension(name);

            // Set up the hash if this is set to open
            if (this.options.action === "open") {
                url = "#catid=";
                if ((typeof catId != "number") && item.ExtraFields) {
                    if (item.ExtraFields.fCatId)
                        url += item.ExtraFields.fCatId;
                    else if (item.ExtraFields.CatID)
                        url += item.ExtraFields.CatID;
                }
                else
                    url += catId;

                if (item.GroupId > 0)
                    url += "&groupid=" + item.GroupId;
                else if (item.FileId > 0)
                    url += "&fileid=" + item.FileId;
                else if (item.presid > 0)
                    url += "&presid=" + item.PresId;
                else if (item.CatId > 0)
                    url = "#catid=" + item.CatId;
                else
                    return;

                url += "&type=" + this.options.catType;
            }

            var listItemEl = new Element("li", {
                "class": "content-item"
            }).injectInside(listEl);

            var nameWrapperEl = new Element('div', {
                "class": "content-name-wrapper"
            }).injectInside(listItemEl);

            var iconEl = new Element("img", {
                "class": "content-icon",
                src: Librarian.Utils.getContentTypeIcon(item)
            }).injectInside(nameWrapperEl);

            var nameEl = new Element('a', {
                "class": "content-name",
                "text": name,
                "title": name
            }).injectInside(nameWrapperEl);

            nameEl.data = data;
            nameEl.addOnClick(function() {
                Librarian.PreviewWindow.openPreviewWindow(this.data);
            });

            if (this.options.detailed) {
                var bookmarkEl = new Element("div", {
                    "class": "content-bookmark"
                }).injectInside(listItemEl);

                Librarian.Bookmarks.getBookmarkId(item.ContentId, item.ContentType, function(bookmarkId) {
                    if (bookmarkId > 0) {
                        bookmarkEl.addClass("bookmarked");
                        bookmarkEl.bookmarkId = bookmarkId;
                    }
                });

                var threeDotEl = new Element("div", {
                    "class": "content-menu-icon"
                }).injectInside(listItemEl);

                var menuEl = new Element("div", {
                    "class": "content-menu-wrapper"
                }).injectInside(listItemEl);

                var downloadEl = new Element("div", {
                    "text": "Download"
                }).injectInside(menuEl);

                var cartEl = new Element("div", {
                    "text": "Add File"
                }).injectInside(menuEl);

                if (self.options.showShareLink) {
                    var shareEl = new Element("div", {
                        "text": "Share"
                    }).injectInside(menuEl);
                }

                var viewEl = new Element("div", {
                    "text": "View in Library"
                }).injectInside(menuEl);

                if (self.options.showGetLink) {
                    var getLinkEl = new Element("div", {
                        "text": "Get Link"
                    }).injectInside(menuEl);

                    getLinkEl.addOnClick(function () {
                        Librarian.Utils.getLink(data);
                    });
                }

                menuEl.hide();

                threeDotEl.addEvent('mouseenter', function() {
                    menuEl.show();
                    menuEl.removeClass("open-above");

                    var menuRect = menuEl.getBoundingClientRect();
                    var contRect = self.containerEl.getBoundingClientRect();
                    var openAbove = menuRect.bottom > contRect.bottom;

                    menuEl.toggleClass("open-above", openAbove);

                    menuRect = menuEl.getBoundingClientRect();
                    var openLeft = menuRect.top < contRect.top;

                    menuEl.toggleClass("open-left", (openAbove && openLeft));

                    threeDotEl.addClass("active");
                });

                menuEl.addEvent('mouseenter', function() {
                    menuEl.show();
                    threeDotEl.addClass("active");
                });

                threeDotEl.addEvent('mouseleave', function() {
                    menuEl.hide();
                    threeDotEl.removeClass("active");
                });

                menuEl.addEvent('mouseleave', function() {
                    menuEl.hide();
                    threeDotEl.removeClass("active");
                });

                downloadEl.addOnClick(function () {
                    Library.downloadData(data);
                });

                cartEl.addOnClick(function () {
               // Can't add to the cart if we don't have a cart
                    if (!Librarian.userCart)
                        return;

                    var item = self.prepCartItem(data, 1),
                        onComplete = function(success, notifyType) {
                            Librarian.Utils.showCartNotification(item, notifyType, success);

                            // Update the checkboxes on the main page
                            Librarian.Utils.updateAllCheckboxes();

                            Librarian.Cart.onChange();

                            // If we're in the cart and we just removed ourselves,
                            // close the window to prevent switching errors.
                            if (success && (notifyType == Librarian.cartNotificationTypes.removed) && this.isInCart)
                                this.close();
                        }.bind(this);

                    // If it's already in the cart, prompt the user to remove it
                    if (Librarian.userCart.isInCart(item, true)) {
                        Librarian.userCart.removeFromCart(item, null, null, null, null, function() {
                            onComplete(!Librarian.userCart.isInCart(item), Librarian.cartNotificationTypes.removed);
                        });
                    }
                        // Otherwise, add it
                    else
                        onComplete(Librarian.userCart.addToCart(item), Librarian.cartNotificationTypes.added);
                });

                if (shareEl) {
                    shareEl.addOnClick(function () {
                        var eventType = Librarian.eventType.oneOff;
                        this.sendWindow = new Librarian.EventSendWindow({
                            onCloseComplete: function () {
                                this.sendFileWindow = null;
                            }.bind(this),
                            eventType: eventType
                        }, data);
                        this.sendWindow.show();
                    });
                }

                viewEl.addOnClick(function () {
                    var tree = Library.getTreeByType(self.options.catType, null, data.prestype);
                    Librarian.Utils.getPath(data, function(path) {
                        if (path != null)
                            Library.loadLibraryTab();
                            Librarian.Utils.selectTreeNodeByPath(tree, path);
                    });
                });

                new Element("span", {
                    "class": "content-field",
                    "text": "Last Modified: " + moddate
                }).injectInside(listItemEl);

                new Element('span',{
                    "class": "content-field",
                    "text": "Author: " + (data.extrafields.Author || ""),
                }).injectInside(listItemEl);

                bookmarkEl.addOnClick(function () {
                    var self = this;
                    if (this.hasClass("bookmarked")) {
                        Librarian.Bookmarks.deleteBookmark(this.bookmarkId, item.ContentId, item.ContentType, function() {
                            self.removeClass("bookmarked");
                        }.bind(this));

                    } else {
                        Librarian.Bookmarks.addBookmark(item.ContentId, item.ContentType, function(bookmarkId) {
                            self.addClass("bookmarked");
                            this.bookmarkId = bookmarkId;
                        }.bind(this));
                    }
                });
            } 

            if (this.options.overlayClass) {
                new Element("div", {
                    "class": this.options.overlayClass
                }).injectInside(listItemEl);
            }
        }.bind(this));

        if (typeof this.options.onPostRender == "function")
            this.options.onPostRender.apply(this);
    },

    prepCartItem: function(data, type) {
        if (!Librarian.Cart)
            return data;

        var item = new Librarian.Cart.Item(data);
        if ((type == Librarian.Utils.getItemTypeString(this.options.data)) && (this.options.data.slidenumber < 1))
            item.slidenumber = 1;
            // Files
        else if (type == Librarian.Lang.getString("item")) {
            if (this.options.data.slidenumber != 0)
                item.slidenumber = 0;
            item.itemnumber = undefined;
            if (this.options.data.slideid != 0)
                item.slideid = 0;
            // Restore the parent extra fields if we're adding this as an item
            if (this.options.parentData && this.options.parentData.extrafields)
                item.extrafields = this.options.parentData.extrafields;
        }
            // Slides/Pages
            // If there is parent data and they have extra fields, save the extrafields as parents fields
        else if (this.options.parentData && this.options.parentData.extrafields)
            item.parentfields = this.options.parentData.extrafields;

        // Reset the add type for this item so the cart can process it correctly
        item.addType = null;

        return item;
    }
});